import { useQuery } from '@tanstack/react-query';
import { useCompany } from '@/contexts/CompanyContext';
import { useDirection } from '@/contexts/DirectionContext';
import { currentOfferPricesApi } from '../api/currentOfferPrices.api';
import type { CurrentOfferPrices } from '../interfaces/currentOfferPrices.interface';

interface UseCurrentOfferPricesResult {
  data: CurrentOfferPrices | null | undefined;
  isLoading: boolean;
  isFetching: boolean;
  error: Error | null;
  refresh: () => void;
}

export function useCurrentOfferPrices(): UseCurrentOfferPricesResult {
  const { selectedCompanyId } = useCompany();
  const { direction } = useDirection();
  const companyId = typeof selectedCompanyId === 'number' ? selectedCompanyId : undefined;

  const query = useQuery<CurrentOfferPrices | null>({
    queryKey: ['dashboard', 'current-offer-prices', selectedCompanyId, direction],
    queryFn: () => currentOfferPricesApi.get(companyId, direction),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: (query.error as Error) || null,
    refresh: () => {
      void query.refetch();
    },
  };
}
